import React from "react";
import PropTypes from "prop-types";
import queryString from "query-string";
import { history } from "store";

// import SplashScreen from "components/SplashScreenContainer";
import { handleNativeAction } from "helpers/nativeActions";
import { NATIVE_ACTION } from "helpers/constants";
// import { handleNativeAction } from "helpers/nativeActions";
// import { NATIVE_ACTION } from "helpers/constants";
class AuthPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
    };
  }


  render() {
    // return <SplashScreen />;
    return false;
  }
}

AuthPage.propTypes = {
  location: PropTypes.object.isRequired,
  login: PropTypes.func.isRequired,
  saveENV: PropTypes.func.isRequired,
  saveMobileLayout: PropTypes.func.isRequired,
  logRequest: PropTypes.func.isRequired,
};

export default AuthPage;
